<script setup>
import { computed, ref } from 'vue';
import { __, formatBytes, requestPlanCTPbyID, decodeHtmlEntities,convertSecondsToMinutes } from '@/utils'

import Modal from "@components/modal.vue";

const planModal = ref(false);

const props = defineProps({
    data: Object,
    main: {
        type: Boolean,
        default: false
    },
    hideName: {
        type: Boolean,
        default: false
    },
})


const planCPT = ref('');
const planTotalData = ref(formatBytes(props?.data?.totals?.DATA).endValue);
const planDataType = ref(formatBytes(props?.data?.totals?.DATA).unit);

const fetchPlanCPT = async (id) => {
    try {
        const response = await requestPlanCTPbyID(id);
		planCPT.value = response;
    } catch (error) {
        console.error('Error fetching plans:', error);
    }
};

const dataService = computed(() => {
    return props.data?.services_balances?.find(service => service.usage_type === 'data')
});

const calculatedData = computed(() => {
    if (dataService.value?.group_balance?.total) {
        return formatBytes(dataService.value.group_balance?.total).endValue
    }
    return 0
});

const isUnlimitted = computed(() => {
    if(dataService.value) {
        return dataService.value.group_balance?.total === 'UNLIMITED'
        
    }
    return false
});

const usageType = computed(() => {
    if (props.data?.data?.service_details?.roaming_usage_type === 'callsms') {
        return __('Talking and texting')
    } else if(props.data?.data?.service_details?.roaming_usage_type === 'datacall') {
        return __('Surfing and talking')
    } else if (props.data?.data?.service_details?.roaming_usage_type === 'data') {
        return __('Browsing only')
    }
    return ''
});

const gradientText = computed(() => {
    if (props.data?.data?.service_details?.roaming_usage_type === 'callsms') {
        return convertSecondsToMinutes(props.data?.data.group_balance?.total) + ' ' + __('Minutes and SMS');
    } else if(props.data?.data?.service_details?.roaming_usage_type === 'datacall' || props.data?.data?.service_details?.roaming_usage_type === 'data') {
        const usageData = formatBytes(props.data?.roaming_data.group_balance?.total);
        return usageData.endValue + usageData.unit;
    } 
    return ''
});

if ( props?.data?.aos_product_id){
    fetchPlanCPT(props.data.aos_product_id);
}
</script>
<template>
    <div class="plan-info">
        <img class="check-icon" :src="`${theme_path.url}/resources/images/ico-check.svg`" alt="">
        <h5 class="plan-info__header" v-if="!main">{{ usageType }}</h5>
        <h5 class="plan-info__header" v-if="main">{{ decodeHtmlEntities(data.plan) }}</h5>
        <h3 class="plan-info__unit">
            <span class="gradient" v-if="!isUnlimitted && !main">{{ gradientText }}</span>
            <span class="gradient" v-if="!isUnlimitted && main">{{ calculatedData || data?.capacity || planTotalData }}{{ data?.capacityUnit || planDataType }}</span>
            <span class="gradient" v-if="isUnlimitted">{{ __('Unlimited browsing') }}</span>
        </h3>
        <p class="plan-info__country gradient" v-if="!main"><strong>{{ data?.data?.service_details?.roaming_country_name_heb  }}</strong></p>
        <div class="divider"></div>

        <slot />

        <!-- TODO: add modal logic -->
        <div class="plan-cta" v-if="false">
            <a href="#" @click.prevent="planModal = true">
                <img :src="`${theme_path.url}/resources/images/ico-tooltip.svg`" />
                <span>{{ __('for package details') }}</span>
            </a>
            <!-- Hide per request -->
            <a v-if="false">
                <img :src="`${theme_path.url}/resources/images/svg/icon-close.svg`" /> 
                <span>{{ __('Termination of service') }}</span>
            </a>
        </div>
    </div>
    <Modal :isActive="planModal" @close="planModal = false">
        <template #head>
            <p>
                {{data?.plan}}
            </p>

            <h2 class="gradient">
                 {{planTotalData }}{{planDataType }}
            </h2>
        </template>
        <template #body>
            <div class="popup__body-right" v-if="planCPT?.data?.popup_text">
               <span dir="rtl" v-html="planCPT.data.popup_text"></span>
            </div>
        </template>
        <template #foot>
            <a href="#" class="btn" type="button" @click.prevent="planModal = false">
                {{ __('Accept') }}
            </a><!-- /.btn -->
        </template>
    </Modal>
</template>